export const COMMENTS_HISTORY = 'Comments are not available!'
export const SCHEDULING_IMPACT_MITIGATION_PLAN_HISTORY = `Scheduling Impact & Mitigation 
Plan History is not available`
export const OPERATION_IMPACT_MITIGATION_PLAN_HISTORY = `Operations Impact & Mitigation 
Plan History is not available`
export const SCHEDULING_IMPACT_MITIGATION_PLAN_MODAL_TITLE = `Scheduling Impact & Scheduling Impact 
& Mitigation Plan`
export const OPERATION_IMPACT_MITIGATION_PLAN_MODAL_TITLE = `Operations Impact & Operations Impact 
& Mitigation Plan`
export const HISTORICAL_TABLE_COMMENTS = 'Comments'
export const HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN = 'MitigationPlanHistory'
export const HISTORICAL_TABLE_OPS_MITIGATION_PLAN = 'OperationsMitigationPlanHistory'